import type { NextJSProjectCacheRouter } from "replo-publisher/src/trpc/routers/nextJSProjectCache";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: nextJSProjectCacheRouter,
  client: nextJSProjectCacheClient,
  utils: nextJSProjectCacheUtils,
  options: nextJSProjectCacheOptions,
} = createTrpcRouterConfig<NextJSProjectCacheRouter>({
  path: "nextJSProjectCache",
  queryClient: getNamespacedQueryClient("nextJSProjectCache"),
});

export {
  nextJSProjectCacheClient,
  nextJSProjectCacheRouter,
  nextJSProjectCacheUtils,
  nextJSProjectCacheOptions,
};
